import userAgentVariables from '../config/userAgentVariables.json'

export const getUserAgentVariableText = (text, market = '') => {
  const marketTitle = market.toLowerCase() !== 'global' ? market : ''

  return userAgentVariables.marketVariables.reduce((replaceableText, variable) => {
    return replaceableText?.replace(new RegExp(variable, 'g'), marketTitle)
  }, text)
}
